import { Text } from '@shared/components';

import { colorMapByDifficultyLevel, DifficultyLevel } from './constants';
import type { PValueCriteria } from './types';

interface DifficultyTextProps {
  criteria?: PValueCriteria;
}

export function DifficultyText(props: Readonly<DifficultyTextProps>) {
  const { criteria } = props;

  return (
    <Text
      variant='body2Semibold'
      color={colorMapByDifficultyLevel[criteria?.difficultyLevel ?? DifficultyLevel.EASY]}
      sx={{
        wordBreak: 'normal',
      }}
    >
      {criteria?.label}
    </Text>
  );
}
